﻿import { Satser } from '../../Utilities/SatserApi';

export const SET_SATSER = 'SET_SATSER';

export interface SetSatserAction {
    type: typeof SET_SATSER;
    payload: Satser;
}

export type SatserActionTypes = SetSatserAction;
